<template>
    <svg v-if="!props.isFavorite" width="56" height="56" viewBox="0 0 56 56" fill="none" xmlns="http://www.w3.org/2000/svg">
        <circle cx="28" cy="28" r="28" fill="#464646" fill-opacity="0.5" />
        <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M27.9996 16.8C27.2263 16.8 26.5995 17.4269 26.5995 18.2001V26.6004H18.1989C17.4256 26.6004 16.7988 27.2272 16.7988 28.0004C16.7988 28.7737 17.4256 
                29.4005 18.1989 29.4005H26.5995V37.8007C26.5995 38.5739 27.2263 39.2007 27.9996 39.2007C28.7728 39.2007 29.3996 38.5739 29.3996 37.8007V29.4005H37.7995C38.5727 
                29.4005 39.1995 28.7737 39.1995 28.0004C39.1995 27.2272 38.5727 26.6004 37.7995 26.6004H29.3996V18.2001C29.3996 17.4269 28.7728 16.8 27.9996 16.8Z"
            fill="white"
        />
    </svg>
    <svg v-else width="56" height="56" viewBox="0 0 56 56" fill="none" xmlns="http://www.w3.org/2000/svg">
        <circle cx="28" cy="28" r="28" fill="#464646" fill-opacity="0.5" />
        <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M28 49C39.598 49 49 39.598 49 28C49 16.402 39.598 7 28 7C16.402 7 7 16.402 7 28C7 39.598 16.402 49 28 49ZM23.4956 35.5878C23.4866 35.5787 23.4777 35.5696 
                23.4689 35.5604L17.2325 29.324C16.6559 28.7474 16.6559 27.8126 17.2325 27.236C17.8091 26.6594 18.744 26.6594 19.3206 27.236L24.54 32.4554L36.6793 
                20.3161C37.2559 19.7395 38.1907 19.7395 38.7673 20.3161C39.3439 20.8927 39.3439 21.8275 38.7673 22.4041L25.607 35.5644C25.5995 35.5722 25.592 35.58 
                25.5843 35.5877C25.3556 35.8164 25.0705 35.9544 24.7738 36.0016C24.3223 36.0738 23.8437 35.9358 23.4956 35.5878Z"
            fill="white"
        />
    </svg>
</template>

<script setup lang="ts">
    const props = defineProps({
        isFavorite: {
            type: Boolean,
            required: true
        }
    });
</script>
